import { toDate } from "./core";

export function formatDate(
    zdt: Temporal.ZonedDateTime,
    pattern = "YYYY-MM-DD",
): string {
    const year = String(zdt.year).padStart(4, "0");
    const month = String(zdt.month).padStart(2, "0");
    const day = String(zdt.day).padStart(2, "0");
    const hour = String(zdt.hour).padStart(2, "0");
    const minute = String(zdt.minute).padStart(2, "0");
    const second = String(zdt.second).padStart(2, "0");

    let result = pattern
        .replace("YYYY", year)
        .replace("MM", month)
        .replace("DD", day)
        .replace("HH", hour)
        .replace("mm", minute)
        .replace("ss", second);

    if (pattern.includes("z")) {
        const tzAbbr = getTimezoneAbbr(zdt);
        result = result.replace("z", tzAbbr);
    }
    return result;
}

export function getTimezoneAbbr(zdt: Temporal.ZonedDateTime): string {
    const timeZone = zdt.timeZoneId;
    const formatter = new Intl.DateTimeFormat("en-US", {
        timeZone,
        timeZoneName: "short",
    });
    const parts = formatter.formatToParts(toDate(zdt));
    return parts.find((p) => p.type === "timeZoneName")?.value ?? timeZone;
}
